import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import WebHookInfo from '../../components/WebHookInfo';
import useApi from '../../api/useApi';
import Notification from '../../components/Notification';
import '../../scrollbar.css';

function WebHooks() {
  // const location = useLocation();
  const [openCreate, setOpenCreate] = useState(false);
  const [selectedWebhook, selectWebhook] = useState({ id: '', name: '' });
  const [{ isLoading, isError, data }, getData] = useApi();
  const [webhook, setWebhook] = useState([]);
  const [onClose, setOnClose] = useState(false);
  const [state, deleteWebhook] = useApi();
  const [action, setAction] = useState('');
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [formData, setFormData] = useState({ q: '', status: '' });
  const [filteredData, setFilteredData] = useState([]);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(localStorage.user).organization.id;

  useEffect(() => {
    user && getData(`/organization/${orgId}/webhooks`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setWebhook(data.webhook);
      setFilteredData(data.webhook);
    }

    if (isError) {
      setType('error');
      setMessage('Unable to fetch Webhook');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const handleDelete = () => {
    deleteWebhook(`/webhook/${selectedWebhook.id}`, 'DELETE');
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  useEffect(() => {
    if (state.data) {
      getData(`/organization/${orgId}/webhooks`, 'GET');
      setType('delete');
      setOnClose(false);
      setMessage('Delete webhook detail successfully');
      setNotification(!notification);
    }
    if (state.isError) {
      setType('error');
      setMessage('Unable to delete webhook');
      setNotification(!notification);
    }
  }, [state]);

  useEffect(() => {
    if (filteredData.length <= 0) {
      return;
    }
    let z = filteredData;
    if (formData.status === '') {
      setWebhook(filteredData);
    }
    // if (formData.q) {
    //   z = z.filter((x) => {
    //     const normalizedQuery = formData.q.toLowerCase();
    //     return (
    //       x?.url?.toLowerCase().indexOf(normalizedQuery) >= 0 ||
    //       x?.eventType?.toLowerCase().indexOf(normalizedQuery) >= 0
    //     );
    //   });
    // }

    if (formData.status) {
      z = z.filter((x) => x?.isActive.toString() === formData.status);
    }

    if (z.length > 0) setWebhook(z);
    else setWebhook([]);
  }, [formData.status]);

  const refreshList = () => {
    getData(`/organization/${orgId}/webhooks`, 'GET');
    // toggleOpenCreate();
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const searchData = () => {
    getData(`/search?type=webhook&searchItem=${formData.q}`, 'GET');
  };

  useEffect(() => {
    if (formData.q === '') {
      getData(`/organization/${orgId}/webhooks`, 'GET');
    }
  }, [formData.q]);


  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-3/12 px-2 text-sm block m-auto rounded-2xl relative">
            <span className="block p-4 font-bold border-b text-textBlue1">Delete Webhook</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-3 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm my-8" style={{ color: '#9B9B9B' }}>
              Do you want to delete webhook {selectedWebhook.name}?
            </span>
            <div className="mb-6 font-bold float-right mr-8 w-2/3">
              {/* <div className="w-1/3" /> */}
              <div className="w-2/3 lg:flex sm:block">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs mr-2 focus:outline-none flex justify-center items-center h-7"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {openCreate && (
        <WebHookInfo
          handleClose={toggleOpenCreate}
          action={action}
          notification={createNotification}
          selectedWebhook={selectedWebhook.id}
          refreshList={() => refreshList()}
        />
      )}

      <div
        className="m-8 fixed bg-white"
        style={{
          filter: openCreate && 'blur(2px)',
          boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
          left: '14%',
          right: '14%',
          width: '81%',
          borderRadius: '6px',
          height: '94vh',
        }}
      >
        <div className="z-50" style={{ height: '22vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-lg">Webhooks</span>

            <div className="block lg:flex mt-1 lg:mt-0">
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCreate();
                }}
              >
                Create New
                <img src="assets/img/Create.svg" className="h-2 ml-2 " alt="" />
              </button>
              {/* <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCreate();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                CREATE
              </button>
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('update');
                  if (selectedWebhook.id) toggleOpenCreate();
                }}
              >
                <img src="assets/img/Edit.svg" className="h-3 mr-2 " alt="" />
                EDIT
              </button>
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  if (selectedWebhook.id) setOnClose(true);
                }}
              >
                <img src="assets/img/Delete.svg" className="h-3 mr-2 " alt="" />
                DELETE
              </button> */}
              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 rounded-sm ml-3 flex justify-between items-center rounded-xl">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    if(e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-3">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-2 flex w-full relative bg-primary text-white">
                <div className=" py-2.5 text-xs font-bold w-11/12">URL</div>
                <div className=" py-2.5 text-xs font-bold w-2/6">EVENT</div>
                <div className=" py-1 text-xs font-bold w-1/6">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.status}
                      name="status"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                <div className=" py-2.5 text-xs font-bold w-1/12"></div>
                <div className=" py-2.5 text-xs font-bold w-1/6">ACTIONS</div>                {/* <div className=" py-4 px-4 text-xs font-bold w-1/6">STATUS</div> */}
                {/* <img src="assets/img/Filter.svg" className="w-5 absolute top-5 right-3" /> */}
              </div>
            </div>
            {!isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '68vh' }}>
                <div className="w-full">
                  {webhook.map((item) => (
                    <div
                      className="my-1 px-8 flex 
                    relative hover:border-indigo-200 focus-within:border-indigo-200"
                      style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    >
                      {/* <input
                      type="checkbox"
                      className="absolute left-3 top-2.5"
                      checked={selectedWebhook.id === item.id}
                      onClick={() => {
                        if (selectedWebhook.id !== item?.id) {
                          selectWebhook({ id: item.id, name: item.eventType });
                        } else {
                          selectWebhook({ id: '', name: '' });
                        }
                      }}
                      // onChange={() => selectWebhook(item.id)}
                    /> */}

                      <div className="text-role text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-11/12">
                        {item?.url}
                      </div>
                      <div className="text-role text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/6">
                        {item?.eventType}
                      </div>
                      <div
                        className={`text-${item?.isActive ? 'green-600' : 'red-600'
                          } text-left py-2 pl-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/6`}
                      >
                        {item?.isActive ? 'Active' : 'Inactive'}
                      </div>
                      <div className=" py-2.5 text-xs font-bold w-1/12"></div>
                      <div className="flex text-role text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/6">
                        <img
                          src="assets/img/Edit2.svg"
                          className="h-3 mr-4 "
                          alt=""
                          onClick={() => {
                            selectWebhook({ id: item?.id });
                            setAction('update');
                            toggleOpenCreate();
                          }}
                        />
                        <img
                          src="assets/img/Delete2.svg"
                          className="h-3"
                          alt=""
                          onClick={() => {
                            selectWebhook({ id: item?.id, name: item?.projectName });
                            setOnClose(true);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default WebHooks;
